import React, { Component } from 'react';

class Label extends Component {
  render() {
    var classes = ['label'];

    if (this.props.type && this.props.type.length > 0) {
      classes.push('label-'+this.props.type);
    }

    return (
      <span className={classes.join(' ')}>{this.props.children}</span>
    );
  }
}

export { Label }
